var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soundtrack"},[_c('div',{staticClass:"video"},[_c('Head')],1),_c('People',{ref:"People"}),_c('Floor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }